import { useIntl } from '@capsicum/common';
import { GenericDrawer, useGoatImage } from '@capsicum/common-web';
import { type AuctionBidNotAllowedDrawerProps } from '@capsicum/features/fanshop/shared';

export const AuctionBidNotAllowedDrawer = ({ onButtonPress }: AuctionBidNotAllowedDrawerProps) => {
	const { $t } = useIntl();
	const goatImage = useGoatImage('surprise');

	return (
		<GenericDrawer
			buttonText={$t('global.button.gotIt')}
			description={$t('rewards.rpAuctions.bid.notAllowedModal.description')}
			image={goatImage}
			imageSize={{ height: 200, width: 300 }}
			isButtonFullWidth
			testID="rp-auction-bid-not-allowed"
			title={$t('rewards.rpAuctions.bid.notAllowedModal.title')}
			onButtonPress={onButtonPress}
		/>
	);
};
